export default {
	analytics: '/admin/forword/analytics', //分析报告
};
